import { put, select, takeLatest, call } from "redux-saga/effects";
import { handleAuthResponse, loginWatcher } from "../actions/loginactioncreators";
import { handleError } from "../actions/loginactioncreators";
import getIsPreAuth from "../helpers/getIsPreAuth";
import getPassword from "../helpers/getPassword";
import getTotpSession from "../helpers/getTotpSession";
import getChallenge from "../helpers/getChallenge";
// import getSaveDevice from "../helpers/getSaveDevice";// TODO COR-1814
import actiontypes from "../actions/actiontypes";
import { CognitoClient } from "../../lib/cognitoClient";

export function* verifyTotpCode(action) {
    try {
        // TODO COR-1814
        // const saveDevice = yield select(getSaveDevice);
        const isPreAuth = yield select(getIsPreAuth);
        if (isPreAuth) {
            yield call(CognitoClient.confirmTotp, action.payload);
            yield put(handleAuthResponse({ isSignedIn: true, nextStep: { signInStep: "DONE" } }));
        }
        else {
            const challenge = yield select(getChallenge);
            const totpSession = yield select(getTotpSession);
            const password = yield select(getPassword);

            const totpPayload = {
                flowStage: "CHALLENGE_MFA_SETUP",
                challengeResponse: {
                    session: challenge.session,
                    challengeName: challenge.challengeName,
                    step: "MFA_SETUP_TOTP",
                    challengeParameters: {
                        USERNAME: challenge.challengeParameters.USER_ID_FOR_SRP,
                        MFA_CONFIG: {
                            TOTP_CODE: action.payload,
                            TOTP_SESSION: totpSession
                        },
                        PASSWORD: password,
                        MFA_OPTIONS: challenge.challengeParameters["MFA_OPTIONS"] ?? undefined
                    }
                }
            };

            yield put(loginWatcher(totpPayload));
        }

        // if (saveDevice) {
        //   // TODO COR-1814 implement device key first
        //   // REQUIRES VALID DEVICE KEY TO HAVE BEEN SET ELSEWHERE
        //   yield cognitoUser.setDeviceStatusRemembered({
        //     onSuccess: function(result) { },
        //     onFailure: function(rememberDeviceFailure) {
        //       // TODO decide what to do here
        //     },
        //   });
        // }
    } catch (error) {
        yield put(handleError(error));
    }
}


export function* watchMfaTotpCodeAsync() {
    yield takeLatest(actiontypes.MFA_VERIFY_TOTP_CODE, verifyTotpCode);
}